import React from 'react';
import {PropTypes} from 'prop-types';
import HrbTranslate from '../language/HrbTranslate';
import './CardWidget.scss';

const CardWidgetContent = (props) => {
  let {contentText, params, className} = props;
  let classes = "hrb-card-widget-content-text"
  if (className) {
    classes += " " + className;
  }
  return (
    <div className={classes}>
      <HrbTranslate text={contentText} params={params}/>
    </div>
  );
}

CardWidgetContent.propTypes = {
  contentText: PropTypes.string,
  params: PropTypes.object,
  className: PropTypes.string
};

export default CardWidgetContent